<template>
	<div style="margin-right:50px">
	  <div class="subTop1">
	    <em>Global Vision</em>
	    <span>寰球视野</span>
	    <router-link to="/huanqiu" class="more" @click.native="$track([['pagetype','首页-寰球视野-更多-点击']])">更多</router-link>
	  </div>
	  <a @click="huanqiuList.data[0].id?jumppush('/detail/'+huanqiuList.data[0].id):''" class="top">
	    <img :src="huanqiuList.data?huanqiuList.images[huanqiuList.data[0].id]:''"/>
	    <p>{{huanqiuList.data?huanqiuList.data[0].title:''}}</p>
	  </a>
	  <ul class="newsWap">
			<li v-for="(item,index) in huanqiuList.data" v-if="index>0&&index<5">
				<a @click="jumppush('/detail/'+item.id)" :title="item.title">{{item.title}}</a>
			</li>
	    <!-- <li><a href="##">印度Jio拟斥资251亿美元部署全国性5G网络</a></li>
	    <li><a href="##">欧洲三国替电信行业发声施压欧盟要求科技巨头共担</a></li>
	    <li><a href="##">欧洲网络中立争议：科技巨头是否该共担建网成本？</a></li>
	    <li><a href="##">目标是世界第一！信实拟斥资250亿美元在印度推出</a></li> -->
	  </ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				huanqiuList: [],
			}
		},
		created:function(){
			this.huanqiufnc();
		},
		computed: {
	
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				debugger
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			huanqiufnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'szjj/searchArticles',
						responseType: 'json',
						params: {
							columnID: '96304454db284dac8991e80882264338',
							// isTopArticle: '1',
							iPage:'1',
							pageSize:'5',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.huanqiuList = response.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		}
	}
</script>

<style>
</style>
